// extracted by mini-css-extract-plugin
export default {"container":"ShippingCard_container__uhLO4","text":"ShippingCard_text__NkO6Q"};